import { isMobile as reactDeviceDetectsMobile } from 'react-device-detect';

export const isMobileDevice = () => {
  if (reactDeviceDetectsMobile) return true;
  if (typeof navigator === 'undefined') return false;

  if (navigator.userAgentData?.mobile) return true;

  // iPadOS can report a Mac desktop user agent when "Request Desktop Site" is on.
  const platform = navigator.userAgentData?.platform || navigator.platform || '';
  return /mac/i.test(platform) && navigator.maxTouchPoints > 1;
};
